import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { Text } from "./Text";

type Props = {
  text: string;
  en?: string;
};

export const TextKv = ({ text, en }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack
      height={isMobile ? 150 : 300}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#438457",
      }}
    >
      <Text
        variant="h1"
        color="#fff"
        fontSize={isMobile ? "25px !important" : "50px !important"}
      >
        {text}
      </Text>
      {en && (
        <Text
          variant="h2"
          color="#fff"
          fontSize={isMobile ? "18px !important" : "35px !important"}
          marginTop={1}
        >
          {en}
        </Text>
      )}
    </Stack>
  );
};
